export var getData = function(dataType){

    return "";
}

var getSeriesData = function(){

}



// WEBPACK FOOTER //
// ./src/echart/echartData.js